module.exports = __webpack_public_path__ + "static/img/similar-1.dbbeef54.jpeg";